export const TicketState = {
  nouveau: 'nouveau',
  encours: 'encours',
  enattente: 'enattente',
  resolu: 'resolu',
} as const;

export type TicketColumnState = typeof TicketState[keyof typeof TicketState];

export type TicketStateConfig = {
  // Libellé affiché dans le silo
  label: string;

  // Libellé affiché sur la page ticket
  ticketLabel: string;

  // Classe CSS associée à l'état
  statusClass: string;

  // Valeur d'état transmise par l'API
  etat: string;

  // États vers lesquels le ticket peut être déplacé
  transitionsAutorisees: TicketColumnState[];
};

export const CONFIG_ETATS_TICKET: Record<TicketColumnState, TicketStateConfig> = {
  [TicketState.nouveau]: {
    label: 'Nouveaux',
    ticketLabel: 'Nouveau',
    statusClass: 'status-new',
    etat: '1',
    transitionsAutorisees: [TicketState.encours, TicketState.enattente, TicketState.resolu],
  },
  [TicketState.encours]: {
    label: 'En cours',
    ticketLabel: 'En cours',
    statusClass: 'status-progress',
    etat: '2',
    transitionsAutorisees: [TicketState.enattente, TicketState.resolu],
  },
  [TicketState.enattente]: {
    label: 'En attente',
    ticketLabel: 'En attente',
    statusClass: 'status-waiting',
    etat: '4',
    transitionsAutorisees: [TicketState.encours, TicketState.resolu],
  },
  [TicketState.resolu]: {
    label: 'Résolu',
    ticketLabel: 'Résolu',
    statusClass: 'status-resolved',
    etat: '3',
    transitionsAutorisees: [],
  },
};
